export default `/* Ids Layout Flex Component */
/* Ids Layout Flex Item Component */
:host([align-self=auto]),
.ids-layout-flex-item-align-self-auto {
  align-self: auto;
}

:host([align-self=baseline]),
.ids-layout-flex-item-align-self-baseline {
  align-self: baseline;
}

:host([align-self=center]),
.ids-layout-flex-item-align-self-center {
  align-self: center;
}

:host([align-self=stretch]),
.ids-layout-flex-item-align-self-stretch {
  align-self: stretch;
}

:host([align-self=flex-start]),
.ids-layout-flex-item-align-self-flex-start {
  align-self: flex-start;
}

:host([align-self=flex-end]),
.ids-layout-flex-item-align-self-flex-end {
  align-self: flex-end;
}

:host([grow="0"]),
.ids-layout-flex-item-grow-0 {
  flex-grow: 0;
}

:host([grow="1"]),
.ids-layout-flex-item-grow-1 {
  flex-grow: 1;
}

:host([shrink="0"]),
.ids-layout-flex-item-shrink-0 {
  flex-shrink: 0;
}

:host([shrink="1"]),
.ids-layout-flex-item-shrink-1 {
  flex-shrink: 1;
}

:host([flex="0"]),
.ids-layout-flex-item-flex-0 {
  flex: 0;
}

:host([flex="1"]),
.ids-layout-flex-item-flex-1 {
  flex: 1;
}

:host([flex="2"]),
.ids-layout-flex-item-flex-2 {
  flex: 2;
}

:host([flex="3"]),
.ids-layout-flex-item-flex-3 {
  flex: 3;
}

:host([flex="4"]),
.ids-layout-flex-item-flex-4 {
  flex: 4;
}

:host([flex="5"]),
.ids-layout-flex-item-flex-5 {
  flex: 5;
}

:host([flex="6"]),
.ids-layout-flex-item-flex-6 {
  flex: 6;
}

:host([flex="7"]),
.ids-layout-flex-item-flex-7 {
  flex: 7;
}

:host([flex="8"]),
.ids-layout-flex-item-flex-8 {
  flex: 8;
}

:host([flex="9"]),
.ids-layout-flex-item-flex-9 {
  flex: 9;
}

:host([flex="10"]),
.ids-layout-flex-item-flex-10 {
  flex: 10;
}

:host([flex="11"]),
.ids-layout-flex-item-flex-11 {
  flex: 11;
}

:host([flex="12"]),
.ids-layout-flex-item-flex-12 {
  flex: 12;
}

:host([flex="13"]),
.ids-layout-flex-item-flex-13 {
  flex: 13;
}

:host([flex="14"]),
.ids-layout-flex-item-flex-14 {
  flex: 14;
}

:host([flex="15"]),
.ids-layout-flex-item-flex-15 {
  flex: 15;
}

:host([flex="16"]),
.ids-layout-flex-item-flex-16 {
  flex: 16;
}

:host([flex="17"]),
.ids-layout-flex-item-flex-17 {
  flex: 17;
}

:host([flex="18"]),
.ids-layout-flex-item-flex-18 {
  flex: 18;
}

:host([flex="19"]),
.ids-layout-flex-item-flex-19 {
  flex: 19;
}

:host([flex="20"]),
.ids-layout-flex-item-flex-20 {
  flex: 20;
}

:host([flex="21"]),
.ids-layout-flex-item-flex-21 {
  flex: 21;
}

:host([flex="22"]),
.ids-layout-flex-item-flex-22 {
  flex: 22;
}

:host([flex="23"]),
.ids-layout-flex-item-flex-23 {
  flex: 23;
}

:host([flex="24"]),
.ids-layout-flex-item-flex-24 {
  flex: 24;
}

:host([overflow=auto]),
.ids-layout-flex-item-overflow-auto {
  overflow: auto;
}

:host([overflow=hidden]),
.ids-layout-flex-item-overflow-hidden {
  overflow: hidden;
}

:host([overflow=visible]),
.ids-layout-flex-item-overflow-visible {
  overflow: visible;
}

:host([overflow=scroll]),
.ids-layout-flex-item-overflow-scroll {
  overflow: scroll;
}

:host(.has-container-grid[grow="0"][shrink="0"]),
.ids-layout-flex-item.has-container-grid.ids-layout-flex-item-grow-0.ids-layout-flex-item-shrink-0 {
  width: 100%;
}

::slotted(ids-input[size=full]) {
  display: inline-block;
}

:host,
.ids-layout-flex {
  display: flex;
}

:host([display=inline-flex]),
.ids-layout-flex-display-inline-flex {
  display: inline-flex;
}

:host([align-content=flex-start]),
.ids-layout-flex-align-content-flex-start {
  align-content: flex-start;
}

:host([align-content=flex-end]),
.ids-layout-flex-align-content-flex-end {
  align-content: flex-end;
}

:host([align-content=center]),
.ids-layout-flex-align-content-center {
  align-content: center;
}

:host([align-content=space-between]),
.ids-layout-flex-align-content-space-between {
  align-content: space-between;
}

:host([align-content=space-around]),
.ids-layout-flex-align-content-space-around {
  align-content: space-around;
}

:host([align-content=space-evenly]),
.ids-layout-flex-align-content-space-evenly {
  align-content: space-evenly;
}

:host([align-content=stretch]),
.ids-layout-flex-align-content-stretch {
  align-content: stretch;
}

:host([align-content=start]),
.ids-layout-flex-align-content-start {
  align-content: start;
}

:host([align-content=end]),
.ids-layout-flex-align-content-end {
  align-content: end;
}

:host([align-content=baseline]),
.ids-layout-flex-align-content-baseline {
  align-content: baseline;
}

:host([align-items=start]),
.ids-layout-flex-align-items-start {
  align-items: start;
}

:host([align-items=end]),
.ids-layout-flex-align-items-end {
  align-items: end;
}

:host([align-items=flex-start]),
.ids-layout-flex-align-items-flex-start {
  align-items: flex-start;
}

:host([align-items=flex-end]),
.ids-layout-flex-align-items-flex-end {
  align-items: flex-end;
}

:host([align-items=center]),
.ids-layout-flex-align-items-center {
  align-items: center;
}

:host([align-items=baseline]),
.ids-layout-flex-align-items-baseline {
  align-items: baseline;
}

:host([align-items=stretch]),
.ids-layout-flex-align-items-stretch {
  align-items: stretch;
}

:host([direction=row]),
.ids-layout-flex-direction-row {
  flex-direction: row;
}

:host([direction=row-reverse]),
.ids-layout-flex-direction-row-reverse {
  flex-direction: row-reverse;
}

:host([direction=column]),
.ids-layout-flex-direction-column {
  flex-direction: column;
}

:host([direction=column-reverse]),
.ids-layout-flex-direction-column-reverse {
  flex-direction: column-reverse;
}

:host([justify-content=start]),
.ids-layout-flex-justify-content-start {
  justify-content: start;
}

:host([justify-content=stretch]),
.ids-layout-flex-justify-content-stretch {
  justify-content: stretch;
}

:host([justify-content=end]),
.ids-layout-flex-justify-content-end {
  justify-content: end;
}

:host([justify-content=flex-start]),
.ids-layout-flex-justify-content-flex-start {
  justify-content: flex-start;
}

:host([justify-content=flex-end]),
.ids-layout-flex-justify-content-flex-end {
  justify-content: flex-end;
}

:host([justify-content=center]),
.ids-layout-flex-justify-content-center {
  justify-content: center;
}

:host([justify-content=left]),
.ids-layout-flex-justify-content-left {
  justify-content: left;
}

:host([justify-content=right]),
.ids-layout-flex-justify-content-right {
  justify-content: right;
}

:host([justify-content=space-between]),
.ids-layout-flex-justify-content-space-between {
  justify-content: space-between;
}

:host([justify-content=space-around]),
.ids-layout-flex-justify-content-space-around {
  justify-content: space-around;
}

:host([justify-content=space-evenly]),
.ids-layout-flex-justify-content-space-evenly {
  justify-content: space-evenly;
}

:host([wrap=nowrap]),
.ids-layout-flex-wrap-nowrap {
  flex-wrap: nowrap;
}

:host([wrap=wrap]),
.ids-layout-flex-wrap-wrap {
  flex-wrap: wrap;
}

:host([wrap=wrap-reverse]),
.ids-layout-flex-wrap-wrap-reverse {
  flex-wrap: wrap-reverse;
}

:host([gap="0"]),
.ids-layout-flex-gap-0 {
  gap: 0px;
}

:host([gap="1"]),
.ids-layout-flex-gap-1 {
  gap: 1px;
}

:host([gap="2"]),
.ids-layout-flex-gap-2 {
  gap: 2px;
}

:host([gap="4"]),
.ids-layout-flex-gap-4 {
  gap: 4px;
}

:host([gap="8"]),
.ids-layout-flex-gap-8 {
  gap: 8px;
}

:host([gap="12"]),
.ids-layout-flex-gap-12 {
  gap: 12px;
}

:host([gap="16"]),
.ids-layout-flex-gap-16 {
  gap: 16px;
}

:host([gap="20"]),
.ids-layout-flex-gap-20 {
  gap: 20px;
}

:host([gap="24"]),
.ids-layout-flex-gap-24 {
  gap: 24px;
}

:host([gap="28"]),
.ids-layout-flex-gap-28 {
  gap: 28px;
}

:host([gap="32"]),
.ids-layout-flex-gap-32 {
  gap: 32px;
}

:host([gap="36"]),
.ids-layout-flex-gap-36 {
  gap: 36px;
}

:host([gap="40"]),
.ids-layout-flex-gap-40 {
  gap: 40px;
}

:host([gap-x="0"]),
.ids-layout-flex-gap-x-0 {
  row-gap: 0px;
}

:host([gap-x="1"]),
.ids-layout-flex-gap-x-1 {
  row-gap: 1px;
}

:host([gap-x="2"]),
.ids-layout-flex-gap-x-2 {
  row-gap: 2px;
}

:host([gap-x="4"]),
.ids-layout-flex-gap-x-4 {
  row-gap: 4px;
}

:host([gap-x="8"]),
.ids-layout-flex-gap-x-8 {
  row-gap: 8px;
}

:host([gap-x="12"]),
.ids-layout-flex-gap-x-12 {
  row-gap: 12px;
}

:host([gap-x="16"]),
.ids-layout-flex-gap-x-16 {
  row-gap: 16px;
}

:host([gap-x="20"]),
.ids-layout-flex-gap-x-20 {
  row-gap: 20px;
}

:host([gap-x="24"]),
.ids-layout-flex-gap-x-24 {
  row-gap: 24px;
}

:host([gap-x="28"]),
.ids-layout-flex-gap-x-28 {
  row-gap: 28px;
}

:host([gap-x="32"]),
.ids-layout-flex-gap-x-32 {
  row-gap: 32px;
}

:host([gap-x="36"]),
.ids-layout-flex-gap-x-36 {
  row-gap: 36px;
}

:host([gap-x="40"]),
.ids-layout-flex-gap-x-40 {
  row-gap: 40px;
}

:host([gap-y="0"]),
.ids-layout-flex-gap-y-0 {
  column-gap: 0px;
}

:host([gap-y="1"]),
.ids-layout-flex-gap-y-1 {
  column-gap: 1px;
}

:host([gap-y="2"]),
.ids-layout-flex-gap-y-2 {
  column-gap: 2px;
}

:host([gap-y="4"]),
.ids-layout-flex-gap-y-4 {
  column-gap: 4px;
}

:host([gap-y="8"]),
.ids-layout-flex-gap-y-8 {
  column-gap: 8px;
}

:host([gap-y="12"]),
.ids-layout-flex-gap-y-12 {
  column-gap: 12px;
}

:host([gap-y="16"]),
.ids-layout-flex-gap-y-16 {
  column-gap: 16px;
}

:host([gap-y="20"]),
.ids-layout-flex-gap-y-20 {
  column-gap: 20px;
}

:host([gap-y="24"]),
.ids-layout-flex-gap-y-24 {
  column-gap: 24px;
}

:host([gap-y="28"]),
.ids-layout-flex-gap-y-28 {
  column-gap: 28px;
}

:host([gap-y="32"]),
.ids-layout-flex-gap-y-32 {
  column-gap: 32px;
}

:host([gap-y="36"]),
.ids-layout-flex-gap-y-36 {
  column-gap: 36px;
}

:host([gap-y="40"]),
.ids-layout-flex-gap-y-40 {
  column-gap: 40px;
}

:host([full-height]),
.ids-layout-flex-full-height {
  height: 100%;
}

::slotted(ids-icon),
.ids-layout-flex > .ids-icon {
  display: inline-flex;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
